import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';
const { formatImage } = require('@ifeng-fe/public_method');

class ProfileSlider extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const committees = content;

        const newList = [committees.slice(0, 4), committees.slice(4)];
        let contentSlide = [];

        if (content && content.map) {
            contentSlide = content.map(item => ({
                title: item.name,
                src: item && item.src ? formatImage(item.src, 174, 174) : '',
                url: item.url,
                description: item.description,
            }));
        }
        const sliderTmpl = function sliderTmpl(contentSlide) {
            return contentSlide.map((item, index) => (
                <li className={styles.item} key={index}>
                    <a href={item.url} target="_blank" rel="noopener noreferrer" className={styles.mask}>
                        <img src={item.src} />
                        <div className={styles.shade}>
                            <div className={styles.bg} />
                            <p className={styles.bgp}>阅读专栏</p>
                        </div>
                    </a>
                    <h3>
                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                            {item.name}
                        </a>
                        <p className={styles.des}>{item.description}</p>
                    </h3>
                </li>
            ));
        };

        const config = {
            dots: false,
            sliderTmpl,
        };

        return (
            <div className={styles.profileSlider}>
                <div className={styles.container}>
                    <ul className={styles.box}>
                        <Slides config={config} content={newList} />
                    </ul>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
ProfileSlider.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
ProfileSlider.defaultProps = {};

export default ProfileSlider;
